export default class Node {

    static fromData(data) {
        if (!data) {
            return;
        }

        let node = new Node();
        node.id = data.id;
        node.title = data.title;
        node.parentDirectory = data.parentDirectory;
        node.rootNode = data.rootNode;
        node.description = data.description;
        node.downloadUrl = data.downloadUrl;
        node.isDirectory = data.isDirectory;
        node.created = data.created;
        node.updated = data.updated;
        node.childNodes = data.childNodes.map((node) => Node.fromData(node));

        return node;
    }

}
